module.exports = __webpack_public_path__ + "bravo.png?084abf551fbcab2a08ce6cef255c4474";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/emote/bravo.png
// module id = 72
// module chunks = 0